import React, { Component } from 'react';
import Box from 'components/UI/Box';
import CollapsableRow from 'components/CollapsableRow';
import { toast } from 'react-toastify';
import axios from 'axios';
import { API_URL, ERROR_HANDLE, DOWNLOAD } from 'config/constants';

class Logs extends Component {
    headerItems = labels.map((label, i) => {
        return (
            <p style={style.titleItem} key={i}>
                {label}
            </p>
        );
    });

    header = () => <div style={style.titleWrapper}>{this.headerItems}</div>;

    state = {
        logs: [],
        filteredGyms: []
    };

    getGyms() {
        const access_token = localStorage.getItem('access_token');
        const toastId = toast('Fetching Logs...');
        axios
            .get(`${API_URL}/admin/sub_admin/logs`, {
                headers: {
                    'x-access-token': access_token
                }
            })
            .then(res => {
                toast.dismiss(toastId);
                this.setState({
                    logs: res.data.data,
                    filteredGyms: res.data
                });
            })
            .catch(err => {
                ERROR_HANDLE(err);
            });
    }

    componentDidMount() {
        this.getGyms();
    }

    render() {
        return (
            <div style={style.wrapper}>
                <Box style={style.box} outline>
                    {this.header()}
                    {gymRows(this.state.logs).map((currentItem, i) => (
                        <CollapsableRow data={currentItem} key={i} />
                    ))}
                </Box>
            </div>
        );
    }
}
export default Logs;

const formatDate = (data) => {
    if(!data) {
        return 'Not-Available'
    } else if(data=='Session active') {
        return (<span style={{color:'green'}}>Active</span>)
    }
    const offset = new Date(data).getTimezoneOffset()*60000;
    const date = new Date(data)
    date.setTime(date.getTime() - offset)
    console.log(date)
    return date.getUTCFullYear() + "/" + (date.getUTCMonth() + 1) + "/" + date.getUTCDate() + " " + date.getUTCHours() + ":" + date.getUTCMinutes() + ":" + date.getUTCSeconds();
}

const gymRows = gyms =>
    gyms.map((currentItem, i) => {
        const style = {
            itemWrapper: {
                display: 'flex',
                width: '100%',
                alignItems: 'center'
            },
            item: {
                flex: '1'
            },
            button: {
                width: '77px',
                height: '29px',
                fontSize: '16px',
                color: '#414141'
            },
            collapsableWrapper: {
                backgroundColor: '#000',
                color: '#b5b5b6',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '10px 0px'
            },
            collapseLabel: {
                fontSize: '10px'
            },
            collapseItem: {
                margin: '0px'
            }
        };
        let persistent = (
            <div>
                <hr style={{ borderTop: '1px solid #b5b5b6', borderRadius: '0.5px' }} />

                <div style={style.itemWrapper}>
                    <p style={{ ...style.item }}>{currentItem.name}</p>
                    <p style={{ ...style.item }}>{currentItem.email}</p>
                    <p style={{ ...style.item }}>{formatDate(currentItem.logged_in)}</p>
                    <p style={{ ...style.item }}>{formatDate(currentItem.logged_out)}</p>
                   
                </div>
            </div>
        );

        return { persistent: persistent };
    });

const labels = ['Name', 'Email', 'Start time', 'End time'];

const style = {
    titleWrapper: {
        display: 'flex'
    },
    titleItem: {
        flex: '1',
        fontSize: '20px',
        color: '#00b4d2'
    },
    box: {
        width: '900px'
    },
    wrapper: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: '10px',
        flexDirection: 'column',
        alignItems: 'center'
    },
};
